import { Icon } from '@/components/ui';

import { LOCALES, useI18n, type Locale } from '@/lib/i18n';

const LABELS: Record<Locale, string> = {
  en: 'English',
  ja: '日本語',
};

export function LocaleSwitcher() {
  const { locale, setLocale, t } = useI18n();

  return (
    <div
      role="group"
      aria-label={t('common.language')}
      title={t('common.language')}
      className="inline-flex items-center gap-1 rounded-[9px] border border-line bg-paper p-0.5"
    >
      <span className="pl-1.5 text-ink-400" aria-hidden="true">
        <Icon name="globe" size={12} />
      </span>
      {LOCALES.map((code) => {
        const active = code === locale;
        return (
          <button
            key={code}
            type="button"
            onClick={() => setLocale(code)}
            aria-pressed={active}

            lang={code === 'ja' ? 'ja' : 'en'}
            className={[
              'min-h-8 rounded-[7px] px-2 text-[11.5px] font-semibold transition-colors',
              active
                ? 'bg-plum-700 text-white'
                : 'text-ink-600 hover:bg-ink-100',
            ].join(' ')}
          >
            {LABELS[code]}
          </button>
        );
      })}
    </div>
  );
}
